/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/credentialLists.config.json";
// import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_POLICY_LIST } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

import { useEmailId } from "../../../pages/ProvisionalPage/provider";
import moment from "moment";
import { toHeaderCase } from "js-convert-case";

const lookup = require("country-code-lookup");

export interface IPolicyListsMethods extends IPluginMethodMap {
  getPolicyListsProps(args: any): Promise<any>;
}

export interface IGetCredentialIssuedListProps {
  offset?: number;
  size?: number;
  where?: any;
}

export class PolicyListsService implements IAgentPlugin {
  readonly methods: IPolicyListsMethods;

  constructor() {
    this.methods = {
      getPolicyListsProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetCredentialIssuedListProps) {
    console.log(`args in service:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let _yearFilter = args?.where?.filter(
      (item:any) => item?.column === "purchasedAt"
    )
    let _yearFilter1 = _yearFilter && _yearFilter?.length > 0 ? [{
      column: "purchasedAt",
      value:parseInt(_yearFilter[0].value),
      op:"YearMatch"
    }]:[];

    let _countryFiler = args?.where?.filter((item:any)=>item?.column ==="countryToBeInsured");
    let _countryFiler1 = _countryFiler && _countryFiler?.length > 0 ? [{
      column:"countryToBeInsured",
      value:_countryFiler[0]?.value,
      op:"Equal"
    }]:[];

    let _where1 = args?.where?.filter(
      (item:any) => item?.column === "policyNumber" || item?.column ==="status" 
    );
    let _where2 = args?.where?.filter(
      (item:any) => item?.column !== "policyNumber" && item?.column !== "status" && item?.column !=="purchasedAt" && item?.column !== "countryToBeInsured"
    );
    try {
      if (client) {
        const res = await client.query({
          query: GET_POLICY_LIST,
          variables: {
            input: {
              skip: args?.offset ?? 0,
              limit: args?.size ?? 10,
              where: [
                {
                  column: "type",
                  value: ["ACTUAL"],
                  op: "Equal",
                },
                {
                  column: "status",
                  value: ["EXPIRED"],
                  op: "NotIn",
                },
                ..._yearFilter1,
                ..._where1,
                ..._countryFiler1
              ],
              order: [
                {
                  column: "purchasedAt",
                  direction: "DESC",
                },
              ],
              relationFilter: {
                purchasedBy: {
                  where: [..._where2],
                  limit: args?.size ?? 10,
                  skip: args?.offset ?? 0,
                },
              },
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatTable(res?.data?.getListOfPolicies?.data);
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getListOfPolicies?.data?.length <= 0,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfPolicies?.currentPage,
            pageSize: res?.data?.getListOfPolicies?.pageSize,
            totalCount: res?.data?.getListOfPolicies?.totalCount,
            totalPages: res?.data?.getListOfPolicies?.totalPages,
          };
        }
      }
    } catch (err: any) {
      return {
        isEmpty: true,
      };
    }

    // return { ...(config || {}) };
  }

  private formatTable(tableData: any) {
    let _rowData =
      Array.isArray(tableData) &&
      tableData.map((item: any) => {
        return {
          rowData: item,
          id: item?.policyId,
          country:item?.countryToBeInsured && item?.countryToBeInsured.length === 2
          ? lookup.byIso(`${item?.countryToBeInsured}`)?.country
          : "-",
          countryCode: item?.countryToBeInsured,
          vid: item?.purchasedBy?.vuid,
          policyNo: item?.policyNumber,
          status:item?.status,
          name: `${toHeaderCase(item?.purchasedBy?.firstName ?? "")} ${toHeaderCase(item?.purchasedBy?.lastName ?? "")}`,
          email: item?.purchasedBy?.email,
          // image:item?.image,
          dateCreated: item?.purchasedAt
            ? moment(item?.purchasedAt).format("LLL")
            : "-",
          coverage: item?.coverage,
          premium: item?.premium,
          discount:(item?.discountedPremium && item?.discountedPremium !== item?.premium )? item?.discountedPremium : "NA" ,
          //discount:item?.discountedPremium,
          policyOption: `Policy Option ${item?.productDefination}`,
        };
      });
    return _rowData;
  }
  // return { ...(config || {}) };
}
